module.exports = __webpack_public_path__ + "static/media/12.f2f46216.jpg";